import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginInput, LoginBtn } from "components/login";
import { ReactComponent as Logo } from "assets/login/logo.svg";
import { postLogin } from "service/api/login";
import responseCodeConstant from "service/constant/responseCodeConstant";
import tokenConstant from "service/constant/tokenConstant";
import routerConstant from "service/constant/routerConstant";

export function LoginPage() {
  const navigate = useNavigate();
  const [emailValue, setEmailValue] = useState<string>("");
  const [passwordValue, setPasswordValue] = useState<string>("");
  const [isLoginErr, setIsLoginErr] = useState<boolean>(false);

  //   const handleAutoLoginInput = () => {
  //     setIsAutoLogin((prev) => !prev);
  //   };

  const handleLoginBtn = async () => {
    if (emailValue && passwordValue) {
      const loginRes = await postLogin({
        email: emailValue,
        password: passwordValue,
      });
      if (loginRes.status === responseCodeConstant.SUCCESS.ok) {
        localStorage.setItem(
          tokenConstant.ACCESSTOKEN,
          loginRes.data.data.accessToken,
        );
        localStorage.setItem(
          tokenConstant.REFRESHTOKEN,
          loginRes.data.data.refreshToken,
        );
        navigate(routerConstant.BURIAL.list);
      } else if (
        loginRes.request?.status === responseCodeConstant.ERROR.conflict
      ) {
        setIsLoginErr(true);
      } else {
        window.alert("네트워크 에러");
      }
    } else {
      window.alert("이메일, 비밀번호를 확인해주세요");
    }
  };

  const handleKeypress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleLoginBtn();
    }
  };

  return (
    <div className="flex min-h-[100vh] w-full min-w-[1440px] items-center justify-center bg-gray-6">
      <div className="flex h-[646px] w-[768px] flex-col items-center rounded-[13px] bg-white px-[169px] pt-[121px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
        <Logo className="mb-[80px]" />
        <div className="flex w-full flex-col gap-[12px]">
          <LoginInput
            value={emailValue}
            setValue={setEmailValue}
            onKeyPress={handleKeypress}
            placeholder="이메일"
          />
          <LoginInput
            value={passwordValue}
            setValue={setPasswordValue}
            onKeyPress={handleKeypress}
            placeholder="비밀번호"
            type="password"
          />
          {isLoginErr ? (
            <p className="m-0 ml-[16px] mt-[-4px] text-R1 text-red-1">
              아이디, 비밀번호를 확인해주세요.
            </p>
          ) : (
            <div className="h-[16px]" />
          )}
        </div>
        <div className="mt-[16px] w-full">
          {/* <label className="mb-[12px] flex items-center justify-end gap-[6px]">
            <input
              type="checkbox"
              checked={isAutoLogin}
              onChange={handleAutoLoginInput}
              className="h-[16px] w-[16px] rounded-[2px] border-gray-5 text-blue-1 outline-none focus:ring-white"
            />
            <p className="m-0 text-R1 text-gray-5">자동 로그인</p>
          </label> */}
          <LoginBtn onClick={handleLoginBtn} />
        </div>
      </div>
    </div>
  );
}
